Namespace 'Common.Sessions'

class Common.Sessions.SharedSessionModal extends Backbone.View
  template: JST['backbone/templates/common/sessions/shared_session_modal']
  id: 'shared-session-modal'
  className: 'modal fade'

  events:
    'click #share': '_shareSession'
    'click #stop-sharing': 'onClickStopSharing'
    'click #copy-button': '_copyUrl'

  initialize: ({session}) ->
    @title = ''
    @session = session
    @sharedSession = session.sharedSession
    @isLoading = false

  render: ->
    isSharing = @sharedSession != undefined
    @$el.html(@template(
      isSharing: isSharing
      title: @sharedSession?.get('title') || @title
      URL: @sharedSession?.get('url')
      isLoading: @isLoading
    ))
    @$el.modal()
    @$el.on('hidden.bs.modal', => @.remove())
    @$el.on('shown.bs.modal', => if isSharing then @$el.find('#copy-button').focus() else @_titleInputEl().focus())
    @

  _shareSession: ->
    @isLoading = true
    @title = @_titleInputEl().val()
    @render()
    @session.createSharedSession(@title, @_updateStatus)

  _updateStatus: (sharedSession) =>
    @sharedSession = sharedSession
    @isLoading = false
    @render()

  onClickStopSharing: ->
    swal
      title: I18n.t('monitoring.dashboard.session_sharing.stop_sharing_confirmation')
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      confirmButtonText: I18n.t('monitoring.dashboard.session_sharing.stop_sharing_yes')
      cancelButtonText: I18n.t('monitoring.dashboard.session_sharing.stop_sharing_no')
      closeOnConfirm: true
      customClass: 'common'
      => @_stopSharing()

  _stopSharing: =>
    @isLoading = true
    @render()
    @session.deleteSharedSession(=> @$el.modal('hide'))

  _copyUrl: ->
    input = @$el.find('#shared-session-url')[0]
    input.select()
    document.execCommand('copy')

  _titleInputEl: ->
    @$el.find('#shared-session-title')
